import { render, staticRenderFns } from "./MilestoneTemplateDetailEdit.vue?vue&type=template&id=6d17da0d&"
import script from "./MilestoneTemplateDetailEdit.vue?vue&type=script&lang=js&"
export * from "./MilestoneTemplateDetailEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports